var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:{ active: _vm.selected, disabled: _vm.disable }},[_c('span',{staticClass:"slider round",on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }